
import {debounceTime} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { Configuration } from '../../app.constants';
import * as moment from 'moment'
import { NotificationService } from '../../shared/services/notification.service';

@Injectable()
export class WorkgroupService {
  public notify = {
    associateId: '',
    message: '',
    type: '',
    actionUrl: ''
  }


  constructor(
    private router: Router,
    private _http: HttpClient,
    private config:Configuration,
    private notificationService:NotificationService,

  ) { }

  public createWorkGroup(workgroup: any){
    console.log(workgroup);
    if (workgroup != null) {
      return this._http.post(`${this.config.ServerApiUrl}/WorkingGroup/create`,workgroup);
     }
}

  public getWorkGroup(id?: any):Promise<any>{
    return new Promise(resolve=>{
        this._http.post(`${this.config.ServerApiUrl}/WorkingGroup/read`,{ids:id}).subscribe(res=> {
          resolve(res)});
    });
  }

  public getWorkGroupPaging(index: any,size:any):Promise<any>{
    return new Promise(resolve=>{
        this._http.get(`${this.config.ServerApiUrl}/WorkingGroup/readAll/${index*size}/${size}`).pipe(debounceTime(500)).subscribe(res=> {
          resolve(res);
        });
    });
  }

  public updateWorkGroup(group: any):Promise<any>{
    return new Promise(resolve=>{
      if (group) {
        this._http.put(`${this.config.ServerApiUrl}/WorkingGroup/update`,group).subscribe(res=> {
          resolve(res)
        },(error)=>{
        });
      }
      else 
        resolve('Empty Object');  
    });
  }

  public getWorkGroupFiltered(search: any,pagesize:any,pageindex:any,startDate:any,endDate:any,groupStatus:any,sort:any,approval?:any,privacy?:any) {
    var body={
      startdate: startDate ? startDate : '',
      enddate: endDate ? endDate : '',
      approval:approval,
      regex:search,
      skip:pageindex*pagesize,
      limit:pagesize,
      privacy:privacy,
      sort:sort,
      status:(groupStatus === "" ? ['Inactive','Active']: groupStatus)
    }

    // if(startDate){
    //   body.startdate=startDate
    // }
    // if(endDate)
    //   body.enddate=endDate;
    return this._http.post(`${this.config.ServerApiUrl}/WorkingGroup/readAllReg`,body).pipe(debounceTime(500));
  }

  public sendMail(member:any,group:any,option:any):Promise<any>{
    return new Promise(resolve=>{
      var message="";
      if(option==-1){
        const message=`Your participation in <b>${group.groupAlias}</b> has ended as of <b class='fw-bold'>${moment().format('DD MMM YYYY').toString()}</b>`
        this.sendInfoEmail(member.email,message);
        this.removeFromNotification(member.associateId, group.groupAlias, group._id);
      }else if(option==0){
        const message=`You're now a <b class='fw-bold'>${member.role}</b> in the <b class='fw-bold'>${group.groupAlias}</b>, assigned by <b class='fw-bold fw-bold'>${group.lastEditedBy[0].name}</b>`
        this.sendInfoEmail(member.email,message);
        this.addToNotification(member.associateId,member.role,group.groupAlias,group.lastEditedBy[0].name, group._id);
      }else if(option==1){
        // rejected
        this.sendApprovalMail('Disapproved',group.groupAlias,member.email);
        this.workgroupDisapprovedNotification(member.associateId, group.groupAlias, group.lastValidatedBy.name, group._id);
      }else if(option==2){
        this.sendApprovalMail('Approved',group.groupAlias,member.email);
        this.workgroupApprovalNotification(member.associateId,group.groupAlias,group.privacySetting, group._id);
      }
    });
  }

  public sendApprovalMail(status,alias,email){
    this._http.post(`${this.config.ServerApiUrl}/WorkingGroup/sendEmail`,{status:status,alias:alias,email:email}).subscribe(res=> {});
  }

  public sendInfoEmail(email, message){
    this._http.post(`${this.config.ServerApiUrl}/WorkingGroup/sendWorkgroupEmail`,{email:email,message:message}).subscribe(res=> {});
  }
  sendNotification(associateId:any,message:any,groupId){
    this.notify.associateId=associateId;
    this.notify.message=message;
    this.notify.type='Workgroup';
    this.notify.actionUrl = `/home/working-group/profile/${groupId}`;
    if(this.notify.associateId)
      this._http.post(`${this.config.ServerApiUrl}/notification/create`,this.notify).subscribe(noti=>{});
  }

  sendValidationAction(action: any) {
    this._http.post(`${this.config.ServerApiUrl}/actionCenter/create`, action).subscribe(noti => { });
  }

  public getWorkGroupsByName(searchText: string) {
    return this._http.post(`${this.config.ServerApiUrl}/WorkingGroup/search`, {'search': searchText});
  }

  addToNotification(associateID,role,groupName,userName,groupId){
    const msg=`You're now a <strong class='fw-bold'>${role}</strong> in the <strong class='fw-bold'>${groupName}</strong>, assigned by <strong class='fw-bold fw-bold'>${userName}</strong>`;
    this.notificationService.sendNotification(associateID,msg,'Workgroup',`/home/working-group/profile/${groupId}`)  }
  
    roleChangeNotification(associateID,oldRole,newRole,groupName,userName,groupId){
    const msg=`Your role as <strong class='fw-bold'>${oldRole}</strong> was changed to <strong class='fw-bold'>${newRole}</strong> for <strong class='fw-bold'>${groupName}</strong>, as updated by <strong class='fw-bold fw-bold'>${userName}</strong>`;
    this.notificationService.sendNotification(associateID,msg,'Workgroup',`/home/working-group/profile/${groupId}`);
  }
  
  workgroupApprovalNotification(associateID,groupName,privacy,groupId){
    const msg=`Your Workgroup <strong class='fw-bold'>${groupName}</strong> is now approved for <strong class='fw-bold'>${privacy}</strong> view`;
    this.notificationService.sendNotification(associateID,msg,'Workgroup',`/home/working-group/profile/${groupId}`)
  }
  
  workgroupArchiveNotification(associateID,groupName,groupId){
    const msg=`Your access to <strong class='fw-bold'>${groupName}</strong> has ended as it has now been archived`;
    this.notificationService.sendNotification(associateID,msg,'Workgroup',`/home/working-group/profile/${groupId}`)
  }
  
  workgroupUpdateNotification(){

  }

  workgroupDisapprovedNotification(associateID,groupName, userName, groupId){
    const msg=`The requested workgroup <strong class='fw-bold'>${groupName}</strong> has been disapproved by <strong class='fw-bold fw-bold'>${userName}</strong>`;
    this.notificationService.sendNotification(associateID,msg,'Workgroup',`/home/working-group/profile/${groupId}`)
  }
  
  removeFromNotification(associateID,groupName,groupId){
    const msg=`Your participation in <strong class='fw-bold'>${groupName}</strong> has ended as of <strong class='fw-bold'>${moment().format('DD MMM YYYY').toString()}</strong>`
    this.notificationService.sendNotification(associateID,msg,'Workgroup','home/associate/feed')
  }

}


